import { Component, OnInit, ViewChild } from '@angular/core';
import {
  CardTokenQuery,
  CardToken,
  TransactionType,
  MemberQuery,
  MemberCard,
  MemberCardQuery,
  BalanceQuery,
  config,
  ProviderName,
} from '@fgb/core';
import { Observable } from 'rxjs';
import { CardTokenListComponent } from 'src/app/modules/ecash/components/card-token-list/card-token-list.component';
import { Regex } from 'src/app/shared/utilities/regex';

@Component({
  selector: 'fgb-bulls-pay-page',
  templateUrl: './bulls-pay-page.component.html',
  styleUrls: ['./bulls-pay-page.component.scss'],
})
export class BullsPayPageComponent implements OnInit {
  defaultCardToken$: Observable<CardToken>;
  memberCard$: Observable<MemberCard | undefined>;
  combinedCard$: Observable<number | undefined>;
  @ViewChild('mobileCardTokenList', { static: false }) mobileCardTokenList: CardTokenListComponent;

  constructor(
    private cardTokenQuery: CardTokenQuery,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private balanceQuery: BalanceQuery
  ) {}

  transactionStartDate: Date;
  transactionEndDate: Date;
  transactionType: TransactionType;
  // expose the enum to the template
  transactionTypes = TransactionType;
  memberId: string;

  regex = Regex;
  provider = ProviderName.Sage;
  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.memberId = this.memberQuery.getUserContext().memberId;
    this.transactionType = TransactionType.ecash;
    this.transactionEndDate = new Date();
    this.transactionStartDate = new Date();
    this.transactionStartDate.setDate(new Date(this.transactionStartDate).getDate() - 1);
    this.defaultCardToken$ = this.cardTokenQuery.selectDefaultCard();
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
  }

  setTransactionType(type: TransactionType) {
    this.transactionType = type;
  }
}
